import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import styled from 'styled-components';

import { Flame } from './svg/flame';

export const FlameIcon = (props: Partial<CustomIconComponentProps>) => (
  <IconContainer>
    <Icon component={Flame} {...props} />
  </IconContainer>
);

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.light.colors.brand[100]};

  svg {
    fill: ${({ theme }) => theme.light.colors.brand[500]};
  }
`;
